// src/api/productApi.js
import axios from 'axios';

const API_BASE_URL = 'https://admin.thefoodies.in/api';

// Get the auth token from localStorage
const getAuthToken = () => {
  return localStorage.getItem('token');
};

export const productApi = {
  // ✅ GET - Fetch all active products
  getActiveProducts: async () => {
    try {
      const token = getAuthToken();
      console.log('🔑 Token being used:', token ? 'Present' : 'Missing');
      
      const response = await axios.get(`${API_BASE_URL}/products`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      console.log('✅ Products fetched successfully:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Error fetching products:', error.response?.data || error.message);
      throw error;
    }
  },

  // ✅ POST - Filter Products by Type
  filterProducts: async (filterData) => {
    try {
      const token = getAuthToken();
      console.log('🔄 Filtering products with:', filterData);
      
      const response = await axios.post(`${API_BASE_URL}/products/filter`, filterData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      console.log('✅ Products filtered successfully:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Error filtering products:', error.response?.data || error.message);
      throw error;
    }
  },

  // ❌ REMOVED: getProductById - API doesn't have this endpoint
  // Product details will be fetched from /products endpoint
};

export default productApi;